// Copyright (c) 2025 Comsearch, Inc., All rights reserved

import React from "react";
import GeneratingMessageForFinalizationMailingList from "./documentGenerationNotification/GeneratingMessageForFinalizationMailingList";
import { success } from "react-notification-system-redux";

const documentGenerationNotificationForMailingList =
  (jobData) => (dispatch) => {
    const { mailingListExportJobId, mailingListJobStatus, message } = jobData;

    const uid = `document-generation-notification-${mailingListExportJobId}`;

    const config = {
      uid,
      title: message,
      position: "br",
      autoDismiss: 0,
      dismissible: false,
      children: (
        <GeneratingMessageForFinalizationMailingList
          exportJobId={mailingListExportJobId}
          initialJobStatus={mailingListJobStatus}
          uid={uid}
        />
      ),
    };

    dispatch(success(config));
  };

export default documentGenerationNotificationForMailingList;
